import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./TeamcompDetails.css";
import Footer from "./Footer";
const API_BASE_URL = "http://152.89.239.247:5000"; // Manuell setzen zum Testen


const TeamcompDetails = () => {
  const { id } = useParams();
  const [grid, setGrid] = useState(Array(5).fill().map(() => Array(5).fill(null)));
  const [extraPokemons, setExtraPokemons] = useState([]);
  const [extraTiles, setExtraTiles] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    fetch(`https://poke-meta.com/api/teamcompdetails/${id}`)
      .then((res) => res.json())
      .then((team) => {
        if (!team || Object.keys(team).length === 0) {
          console.error("Kein Team gefunden");
          return;
        }

        const newGrid = Array(4).fill().map(() => Array(5).fill(null));

        if (team.pokemon_positions) {
          team.pokemon_positions.forEach((p) => {
            const row = Math.floor((p.pos - 1) / 5);
            const col = (p.pos - 1) % 5;
            newGrid[row][col] = p.image; // Setzt das Pokémon-Bild in die richtige Position
          });
        }

        setGrid(newGrid);
        setExtraPokemons(team.extra_pokemons || []);
        setExtraTiles(team.extra_tiles || []);

        // Video setzen (Falls spezifische Team-ID)
        if (team.id === 1) {
          //setVideoUrl("https://www.youtube.com/embed/tgkYfnFVS4U");
          setVideoUrl("");
        } else {
          setVideoUrl("");
        }
      })
      .catch((err) => console.error("Fehler beim Laden:", err));
  }, [id]);

  return (
    <div className="teamcomp-details-container">
      <h1 className="teamcomp-details-title">Teamcomp Details</h1>
      <p>This is the best possible lineup for this team.</p>

      {/* Teamcomp Grid */}
      <div className="grid-wrapper">
        {grid.map((row, rowIndex) => (
          <div key={rowIndex} className={`grid-row ${rowIndex % 2 === 1 ? "offset" : ""}`}>
            {row.map((cell, colIndex) => (
              <div key={colIndex} className="grid-cell">
                {cell ? <img src={cell} alt="Pokemon" className="grid-pokemon" /> : null}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Extra Pokémon & Helditems */}
      <div className="extra-pokemon-container">
        <h2>Optimal Pokémon & Helditems</h2>
        <p>Focus on this carry Pokémon and Helditems</p>
        {extraPokemons.map((pokemon, index) => (
          <div key={index} className="extra-pokemon-row">
            <div className="extra-pokemon-slot">
              {pokemon ? <img src={pokemon} alt="Extra Pokemon" className="grid-pokemon" /> : ""}  
            </div>
            <div className="extra-tiles">
              {(extraTiles[index] || []).map((tile, tileIndex) => (
                <div key={tileIndex} className="extra-tile">
                  {tile ? <img src={tile} alt="Helditem" className="helditem" /> : ""} 
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* YouTube-Video Vorschau */}
      {videoUrl && (
        <div className="video-container">
          <h2>Video Guide</h2>
          <p>Check out a detailed playthrough with this comp on Youtube</p>
          <iframe
            width="560"
            height="315"
            src={videoUrl}
            title="YouTube Video Guide"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default TeamcompDetails;
